import { AiOutlineClose } from 'react-icons/ai'
import { useRouter } from '../../../utils/helper'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import CouponInformation from '../../../components/CouponInformation'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import styled from '@emotion/styled'
import * as paths from '../../../constant/path'
import { useGetCouponById } from '../../../services/coupon/coupon-query'

const Layout = styled.div`
  padding: 8px 0;
  ${mobile} {
    margin-top: 64px;
  }
`

const CouponDetail = () => {
  const { isMobile } = useScreen()
  const { couponId, page } = useRouter().query
  const { data: couponDetail } = useGetCouponById(+couponId)

  return (
    <Layout>
      {isMobile && (
        <TitleHeader title="เงื่อนไขการใช้คูปอง" icon={<AiOutlineClose />} path={page} />
      )}
      {page === paths.shopCartCoupons() ? (
        <CouponInformation
          couponDetail={couponDetail}
          buttonText="ใช้เลย"
          onClickButton={() => console.log('button2')}
        />
      ) : (
        <CouponInformation couponDetail={couponDetail} />
      )}
    </Layout>
  )
}

export default CouponDetail
